import {lazy} from 'react';

import ROUTES from 'routes';
import ErrorPage from "./ErrorPage";

const Login = lazy(() => import('./Login'));
const NotificationViewer = lazy(() => import('./NotificationViewer'));
const Notification = lazy(() => import('./Notification'));

export const Pages = [
    {
        route: ROUTES.login,
        component: <Login/>,
    },
    {
        route: ROUTES.notificationViewerEmailLogs,
        component: <NotificationViewer/>,
    },
    {
        route: ROUTES.notificationViewerMobilePush,
        component: <NotificationViewer/>,
    },
    {
        route: ROUTES.notificationViewerSlack,
        component: <NotificationViewer/>,
    },
    {
        route: ROUTES.notificationViewerTeams,
        component: <NotificationViewer/>,
    },
    {
        route: ROUTES.notificationViewerPage,
        component: <Notification/>,
    },
    {
        route: ROUTES.errorPage,
        component: <ErrorPage/>,
    },
];
